import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import MessagingActions from 'app/actions/MessagingActions';
import { selectGlobalMessaging } from 'app/selectors/MessagingSelector';
import BatchActionsList from './BatchActionsList';

export class BatchActionsListContainer extends React.PureComponent {
  render() {
    return (
      <BatchActionsList
        actionIsLoading={this.props.actionIsLoading}
        list={this.props.list}
        pageNumber={this.props.pageNumber}
        pageLimit={this.props.pageLimit}
        totalItems={this.props.totalItems}
        globalMessaging={this.props.globalMessaging}
        renderActionsMenu={this.props.renderActionsMenu}
        messagingActions={this.props.messagingActions}
        renderAdditionalControls={this.props.renderAdditionalControls}
        renderAdditionalButtons={this.props.renderAdditionalButtons}
        noticeId={this.props.noticeId}
      >
        {this.props.children}
      </BatchActionsList>
    );
  }
}

const mapStateToProps = state => ({
  globalMessaging: selectGlobalMessaging(state)
});

const mapDispatchToProps = dispatch => ({
  messagingActions: bindActionCreators(MessagingActions, dispatch)
});

BatchActionsListContainer.propTypes = {
  actionIsLoading: PropTypes.bool,
  list: ImmutablePropTypes.list.isRequired,
  pageNumber: PropTypes.number,
  pageLimit: PropTypes.number,
  totalItems: PropTypes.number.isRequired,
  renderActionsMenu: PropTypes.func.isRequired,
  globalMessaging: ImmutablePropTypes.map,
  children: PropTypes.func.isRequired,
  messagingActions: PropTypes.objectOf(PropTypes.func).isRequired,
  renderAdditionalControls: PropTypes.func,
  renderAdditionalButtons: PropTypes.func,
  noticeId: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(BatchActionsListContainer);
